import { render } from "./Q12-Rest.vue?vue&type=template&id=985f4ae8&scoped=true"
import script from "./Q12-Rest.vue?vue&type=script&lang=js"
export * from "./Q12-Rest.vue?vue&type=script&lang=js"

import "./Q12-Rest.vue?vue&type=style&index=0&id=985f4ae8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-985f4ae8"]])

export default __exports__